import React, { useEffect, useRef, Component } from "react";
import RadioButton from "./RadioButton";
//import useUncontrolledProp from 'Uncontrolled'


export default class RadioButtons extends Component {
    constructor(props) {
        super(props);
    }

    render() {
       
    //const options = this.props.options;
    return (
        <div className='Stylesgroup'>
            {this.props.data.map((data, index) => (
                <RadioButton
                    //key={data.value}
                    //groupName={name}
                    value={data}
                    title={data.description}
                    selected={data.selected}
                    name={data.id}
                    onChange={this.props.onChange}
                    readOnly={this.props.readOnly}
                />
            ))}
        </div>
    );
}
};
